export default ({ request }) => ({
    rptCostDepListApi(data = {}) {
      return request({
        url: '/financial/rpt/cost/dep/list',
        method: 'POST',
        data,
      })
    },
  })
  